import React from "react";
import WaveText from "../WaveText";

export default function MultipleChoiceGeneratorPanel({
  showMultipleChoiceGenerator, generatedMultipleChoice, showAskMe, showTemplates,
  showWordDefinitionGenerator, showWordTranslationGenerator, showTrueFalseGenerator,
  showWarmUpDiscussionGenerator, showCreateDialogueGenerator, showEssentialVocabularyGenerator,
  showLeadInActivitiesGenerator, showFourOpinionsGenerator, showCommunicativeSituationsGenerator,
  showMatchingHalvesGenerator, showErrorCorrectionGenerator, showGrammarRulesGenerator,
  showJumbledSentenceGenerator,
  multipleChoiceMode, setMultipleChoiceMode,
  multipleChoiceInput, setMultipleChoiceInput,
  multipleChoiceLevel, setMultipleChoiceLevel,
  multipleChoiceCount, setMultipleChoiceCount,
  multipleChoiceOptionCount, setMultipleChoiceOptionCount,
  multipleChoiceLoading, setGeneratedMultipleChoice,
  handleMultipleChoiceGenerate, handleMultipleChoiceInsert, handleMultipleChoiceCancel,
}) {
  if (!((showMultipleChoiceGenerator || generatedMultipleChoice) && !showAskMe && !showTemplates && !showWordDefinitionGenerator && !showWordTranslationGenerator && !showTrueFalseGenerator && !showWarmUpDiscussionGenerator && !showCreateDialogueGenerator && !showEssentialVocabularyGenerator && !showLeadInActivitiesGenerator && !showFourOpinionsGenerator && !showCommunicativeSituationsGenerator && !showMatchingHalvesGenerator && !showErrorCorrectionGenerator && !showGrammarRulesGenerator && !showJumbledSentenceGenerator)) {
    return null;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, transition: 'opacity 0.22s, transform 0.22s' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <button onClick={handleMultipleChoiceCancel} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, marginRight: 4 }}>
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none"><path d="M12 16l-4-4 4-4" stroke="#8a2be2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </button>
        <span style={{ fontSize: 16, fontWeight: 600, color: '#22223b' }}>Multiple Choice Exercise</span>
      </div>

      <div style={{ display: 'flex', gap: 4, background: '#f0fdfa', borderRadius: 8, padding: 3 }}>
        {['sentences', 'text'].map(m => (
          <button
            key={m}
            onClick={() => { setMultipleChoiceMode(m); setMultipleChoiceInput(''); setGeneratedMultipleChoice(null); }}
            style={{
              flex: 1, fontSize: 13, fontWeight: 600, padding: '6px 0', borderRadius: 6, border: 'none', cursor: 'pointer', transition: 'all 0.18s',
              background: multipleChoiceMode === m ? '#0d9488' : 'transparent',
              color: multipleChoiceMode === m ? '#fff' : '#0d9488',
            }}
          >
            {m === 'sentences' ? '📝 Sentences' : '📖 Text'}
          </button>
        ))}
      </div>

      <textarea
        value={multipleChoiceInput}
        onChange={e => setMultipleChoiceInput(e.target.value)}
        placeholder={multipleChoiceMode === 'sentences'
          ? 'Describe a grammar/vocabulary topic, or paste your own sentences (one per line)...'
          : 'Describe a topic, or paste your own text — the system will detect which one and act accordingly...'}
        rows={5}
        style={{
          fontSize: 15, padding: '12px', borderRadius: 8, border: '1.5px solid #99f6e4',
          background: '#f0fdfa', resize: 'vertical',
          fontFamily: 'Inter, Segoe UI, Arial, sans-serif', width: '100%', boxSizing: 'border-box'
        }}
      />

      {/* Flex-wrap + minWidth: 0 on the row so dropdowns reflow to a
        * new line when the panel is narrow, instead of forcing a
        * horizontal scroll. Label/select pairs trimmed (CEFR -> Level,
        * tighter gaps, shorter level labels) so all three usually
        * fit on one row at typical panel widths. */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 8, minWidth: 0 }}>
        <label style={{ fontSize: 14, fontWeight: 500, color: '#22223b', display: 'flex', alignItems: 'center', gap: 6 }}>
          Level:
          <select value={multipleChoiceLevel} onChange={e => setMultipleChoiceLevel(e.target.value)}
            style={{ fontSize: 14, padding: '6px 6px', borderRadius: 6, border: '1.5px solid #99f6e4', background: '#fff', cursor: 'pointer' }}>
            <option value="A1">A1</option>
            <option value="A2">A2</option>
            <option value="B1">B1</option>
            <option value="B2">B2</option>
            <option value="C1">C1</option>
            <option value="C2">C2</option>
          </select>
        </label>
        <label style={{ fontSize: 14, fontWeight: 500, color: '#22223b', display: 'flex', alignItems: 'center', gap: 6 }}>
          {multipleChoiceMode === 'sentences' ? 'Sentences:' : 'Gaps:'}
          <select value={multipleChoiceCount} onChange={e => setMultipleChoiceCount(parseInt(e.target.value))}
            style={{ fontSize: 14, padding: '6px 6px', borderRadius: 6, border: '1.5px solid #99f6e4', background: '#fff', cursor: 'pointer' }}>
            <option value={3}>3</option>
            <option value={5}>5</option>
            <option value={7}>7</option>
            <option value={10}>10</option>
          </select>
        </label>
        <label style={{ fontSize: 14, fontWeight: 500, color: '#22223b', display: 'flex', alignItems: 'center', gap: 6 }}>
          Options:
          <select value={multipleChoiceOptionCount} onChange={e => setMultipleChoiceOptionCount(parseInt(e.target.value))}
            style={{ fontSize: 14, padding: '6px 6px', borderRadius: 6, border: '1.5px solid #99f6e4', background: '#fff', cursor: 'pointer' }}>
            <option value={2}>2</option>
            <option value={3}>3</option>
            <option value={4}>4</option>
          </select>
        </label>
      </div>

      <button
        onClick={handleMultipleChoiceGenerate}
        disabled={multipleChoiceLoading || !multipleChoiceInput.trim()}
        className={multipleChoiceLoading ? 'magic-generating-btn' : 'magic-btn'}
        style={{
          fontSize: 15, padding: '12px 16px', borderRadius: 8, border: 'none',
          background: multipleChoiceLoading || !multipleChoiceInput.trim() ? '#e0e0e0' : '#0d9488',
          color: multipleChoiceLoading || !multipleChoiceInput.trim() ? '#999' : '#fff',
          fontWeight: 600, cursor: multipleChoiceLoading || !multipleChoiceInput.trim() ? 'not-allowed' : 'pointer',
          transition: 'all 0.2s', width: '100%',
        }}
      >
        {multipleChoiceLoading ? <WaveText /> : 'Do the magic'}
      </button>

      {generatedMultipleChoice && (
        <div style={{ marginTop: 12, padding: 12, background: '#f0fdfa', borderRadius: 8, border: '1px solid #99f6e4' }}>
          <div style={{ fontSize: 14, fontWeight: 600, color: '#22223b', marginBottom: 8 }}>
            Generated: Multiple Choice ({generatedMultipleChoice.mode === 'text' ? 'Text' : 'Sentences'})
          </div>
          <div style={{ fontSize: 13, color: '#6c757d', marginBottom: 12 }}>
            {generatedMultipleChoice.mode === 'text'
              ? `${(generatedMultipleChoice.gaps || []).length} gaps in passage`
              : `${(generatedMultipleChoice.sentences || []).length} sentences ready`}
          </div>
          <button onClick={handleMultipleChoiceInsert} className="magic-btn"
            style={{ fontSize: 14, padding: '8px 16px', borderRadius: 6, fontWeight: 600, cursor: 'pointer', width: '100%', background: '#0d9488' }}>
            Add
          </button>
        </div>
      )}
    </div>
  );
}
